import './i18n';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { ThemeProvider } from '@/components/ThemeProvider';
import Login from '@/pages/Login';
import AuthCallback from '@/pages/AuthCallback';
import Dashboard from '@/pages/Dashboard';
import Clients from '@/pages/Clients';
import Agents from '@/pages/Agents';
import Assignments from '@/pages/Assignments';
import Reports from '@/pages/Reports';
import Logistics from '@/pages/Logistics';
import Finance from '@/pages/Finance';
import Admin from '@/pages/Admin';
import Calendar from '@/pages/Calendar';
import AlertsCalendar from '@/pages/AlertsCalendar';
import VerifyAgent from '@/pages/VerifyAgent';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import Messages from '@/pages/Messages';
import Corbeille from '@/pages/Corbeille';
import Supervisors from '@/pages/Supervisors';
import Projects from '@/pages/Projects';
import SitesMap from '@/pages/SitesMap';
import MainLayout from '@/layouts/MainLayout';
import ProtectedRoute from '@/components/ProtectedRoute';
import InstallPrompt from '@/components/InstallPrompt';

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id synchronously during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/verify/agent/:token" element={<VerifyAgent />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="clients" element={<Clients />} />
        <Route path="agents" element={<Agents />} />
        <Route path="assignments" element={<Assignments />} />
        <Route path="supervisors" element={<Supervisors />} />
        <Route path="projects" element={<Projects />} />
        <Route path="sites-map" element={<SitesMap />} />
        <Route path="calendar" element={<Calendar />} />
        <Route path="alerts-calendar" element={<AlertsCalendar />} />
        <Route path="reports" element={<Reports />} />
        <Route path="logistics" element={<Logistics />} />
        <Route path="finance" element={<Finance />} />
        <Route path="messages" element={<Messages />} />
        <Route path="trash" element={<Corbeille />} />
        <Route path="admin" element={<Admin />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <AppRouter />
          <InstallPrompt />
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
